import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgLocation = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.286 7.5a2.34 2.34 0 0 0-.712-1.717 2.34 2.34 0 0 0-1.717-.712 2.34 2.34 0 0 0-1.717.712A2.34 2.34 0 0 0 7.43 7.5c0 .67.237 1.243.711 1.717a2.34 2.34 0 0 0 1.717.712 2.34 2.34 0 0 0 1.717-.712 2.34 2.34 0 0 0 .712-1.717zm2.428 0c0 .69-.104 1.255-.313 1.698l-3.453 7.343a1.219 1.219 0 0 1-1.091.674 1.21 1.21 0 0 1-.64-.181 1.09 1.09 0 0 1-.441-.493L5.313 9.198C5.104 8.755 5 8.19 5 7.5c0-1.34.474-2.485 1.423-3.434.949-.949 2.093-1.423 3.434-1.423 1.34 0 2.486.474 3.434 1.423.949.949 1.423 2.093 1.423 3.434z"
      />
    </svg>
  );
};
export default SvgLocation;
